/**
 * 登录引导态标志。
 *
 * 用于跳转登录（appToken / crm token / 站点跳转）期间——此时 appToken → token
 * 的交换是异步的（redirectSignInByTicket → getSession 两次请求），存在一段
 * “cookie 里还没有 token” 的窗口期。若此期间其它组件发出的鉴权请求先返回 401，
 * request.ts 的响应拦截器会删掉正在成形的登录态 cookie 并跳到 /login，
 * 造成“后端登录成功、前端却停在登录页”的偶发问题。
 *
 * 引导期间置为 true，拦截器据此跳过“删 cookie + 跳登录”的破坏性处理。
 */
let bootstrapping = false;
let clearTimer: ReturnType<typeof setTimeout> | null = null;

// 引导结束后保留标志的缓冲时间（ms）：覆盖那些在“无 token 窗口”发出、
// 但在引导完成后才返回的抢跑请求，避免其 401 事后抹掉刚成功的登录态。
const CLEAR_GRACE_MS = 1500;

/**
 * 开始/结束登录引导态。
 * - value=true：立即置位并取消待清理定时器。
 * - value=false：延迟 CLEAR_GRACE_MS 再清位，给在途请求留缓冲。
 */
export function setAuthBootstrapping(value: boolean): void {
  if (clearTimer) {
    clearTimeout(clearTimer);
    clearTimer = null;
  }
  if (value) {
    bootstrapping = true;
    return;
  }
  clearTimer = setTimeout(() => {
    bootstrapping = false;
    clearTimer = null;
  }, CLEAR_GRACE_MS);
}

export function isAuthBootstrapping(): boolean {
  return bootstrapping;
}
